import { Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Title = styled.h2`
  font-family: sans-serif;
  font-size: 36px;
  line-height: 1.1;
  font-weight: 700;

  padding-top: 32px;
  padding-bottom: 24px;
`;

export const NotificationsContainer = styled.div`
  margin: auto;
`;

export const NotificationAlert = styled(Alert)`
  margin: 12px 6px;
`;

export const NotificationDate = styled.div`
  font-size: 12px;
  font-style: italic;
`;

export const NotificationLink = styled(Link)`
  color: #0594d6;

  &:hover {
    color: #005177;
  }
`;

export const ShowMoreLink = styled.span`
  display: block;
  text-align: center;
  font-size: 0.85rem;
  font-weight: 500;
  color: #0286db;
  cursor: pointer;
  margin-top: 6px;
  padding-bottom: 25px;

  &:hover {
    color: #005177;
  }
`;
